import { defineMessages } from 'react-intl';

export const patientContextApprovalMessages = defineMessages({
  titleForPatient: {
    defaultMessage: 'Update details for {patient}',
    id: 'sq8jjOOZxU',
    description:
      'Title when updating a patient profile. patient is the name or an identifier such as an MRN.',
  },
  createTitleForPatient: {
    defaultMessage: 'Create patient profile for {patient}',
    id: 'XGl+mo0Xsl',
    description:
      'Title when creating a patient profile. patient is the identifier, or a name when there is no identifier.',
  },
  createSubtitleOne: {
    defaultMessage: 'Add {field}',
    id: 'EWMJ1Q5NXb',
    description:
      'Subtitle when creating a patient profile sets one field. field is the field name, such as date of birth.',
  },
  createSubtitleTwo: {
    defaultMessage: 'Add {first} and {second}',
    id: 'R9au+hGmlK',
    description: 'Subtitle when creating a patient profile sets two fields',
  },
  createSubtitleMany: {
    defaultMessage: 'Add {earlier} and {last}',
    id: 'X7emp3UbaI',
    description:
      'Subtitle when creating a patient profile sets three or more fields. earlier lists every field but the last, separated by commas.',
  },
  titleWithoutPatient: {
    defaultMessage: 'Update patient details',
    id: '+EKkJu2MOX',
    description:
      'Title when updating a patient profile and no name or identifier is available',
  },
  profileUnavailableRefusal: {
    defaultMessage:
      'The current patient profile could not be loaded, so this change was refused.',
    id: 'c3ls4ia7QP',
    description:
      'Reason given to the agent when a patient update is refused because the current profile did not load.',
  },
  subtitleOne: {
    defaultMessage: 'Update {field}',
    id: 'Ko1W3Lzmq2',
    description:
      'Subtitle when one patient profile field will change. field is the field name, such as date of birth.',
  },
  subtitleTwo: {
    defaultMessage: 'Update {first} and {second}',
    id: '4RBlj0/utb',
    description: 'Subtitle when two patient profile fields will change',
  },
  subtitleMany: {
    defaultMessage: 'Update {earlier} and {last}',
    id: 'Euvp8GJcuS',
    description:
      'Subtitle when three or more patient profile fields will change. earlier lists every field but the last, separated by commas.',
  },
  none: {
    defaultMessage: 'None',
    id: 'dyYjX+/vF2',
    description: 'Placeholder when a routine field is empty in a before/after diff',
  },
  fieldLabel: {
    defaultMessage:
      '{field, select, first_name {First name} last_name {Last name} birth_date {Date of birth} gender {Gender} phone {Phone} email {Email} allergies {Allergies} current_medications {Current medications} past_medical_history {Past medical history} additional_context {Additional context} demographic_string {Identifier} other {Detail}}',
    id: '/mMOBxa80Z',
    description:
      'Label for a patient profile field on the patient approval cards. field is the field key.',
  },
  fieldPhrase: {
    defaultMessage:
      '{field, select, first_name {first name} last_name {last name} birth_date {date of birth} gender {gender} phone {phone} email {email} allergies {allergies} current_medications {current medications} past_medical_history {past medical history} additional_context {additional context} demographic_string {identifier} other {detail}}',
    id: 'XjbduJcASt',
    description:
      'Lowercase name of a patient profile field, used inside approval card subtitles such as "Update date of birth". field is the field key.',
  },
  genderMale: {
    defaultMessage: 'Male',
    id: 'bvHbpwNeNr',
    description: 'Gender option: male',
  },
  genderFemale: {
    defaultMessage: 'Female',
    id: 'uYuqL4IWdl',
    description: 'Gender option: female',
  },
  genderOther: {
    defaultMessage: 'Other',
    id: 'tjhDSQnc+i',
    description: 'Gender option: other',
  },
  genderUnknown: {
    defaultMessage: 'Unknown',
    id: 'xRkOahld5F',
    description: 'Gender option: unknown or unspecified',
  },
});
